export default __webpack_public_path__ + "CCTV-image.c28944fa.png";